import { Tooltip } from 'component-library';
import { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AppContext } from '../../../contexts/AppContext';
import { LatestSoftwareVersion, SystemDetail } from '../../../models/ApiModels';
import SystemDetailsSoftwareVersion from './SystemDetailsConfiguration/SystemDetailsSoftwareVersion';

interface Props {
  system: SystemDetail;
  latestSoftwareVersion?: LatestSoftwareVersion;
}

export default function SystemDetailsHardwareControlPanel(props: Props) {
  const { isHumphreeUser } = useContext(AppContext);

  const navigate = useNavigate();
  return (
    <div className='border-b border-gray-10'>
      <div className='flex gap-2 my-3'>
        <span className='prose-heading5'>Lightning control panel(s)</span>
        <Tooltip description='The control panel is used to let boaters utilize the features in their Lightning system. There can be more than one control pannel in a Lightning system.' />
      </div>
      <div className='xl:flex xl:justify-between my-5 items-center'>
        <div className='xl:font-normal font-semibold w-48'>Primary</div>
        <div className='2xl:gap-16 xl:flex gap-4'>
          <div className='w-32 flex justify-between items-center truncate'></div>
          {props.system?.lightningHardwareSystem?.primaryControlPanel?.articleNumber && (
            <div className='xl:w-42 flex justify-between items-center'>
              Part no.
              <span className='font-code prose-dataBaseDataLabel ml-3'>
                {props.system?.lightningHardwareSystem?.primaryControlPanel?.articleNumber}
              </span>
            </div>
          )}
          {props.system?.lightningHardwareSystem?.primaryControlPanel?.serialNumber && (
            <div className='xl:w-32 flex justify-between items-center'>
              Serial no.
              <span className='font-code prose-dataBaseDataLabel ml-3'>
                {isHumphreeUser ? (
                  <Link
                    to={'/units/lcp/' + props.system.lightningHardwareSystem?.primaryControlPanel?.serialNumber}
                    className='whitespace-nowrap cursor-pointer underline text-primary-100 hover:text-primary-200'
                  >
                    {props.system?.lightningHardwareSystem?.primaryControlPanel?.serialNumber?.toString()}
                  </Link>
                ) : (
                  props.system?.lightningHardwareSystem?.primaryControlPanel?.serialNumber?.toString()
                )}
              </span>
            </div>
          )}
          {props.system?.lightningHardwareSystem?.primaryControlPanel?.firmwareVersion && (
            <div className='xl:w-42 flex justify-between items-center'>
              Software
              <span className='font-code prose-dataBaseDataLabel ml-3 xl:w-12 xl:truncate'>
                {props.system.lightningHardwareSystem?.primaryControlPanel?.firmwareVersion}
              </span>
            </div>
          )}
          <SystemDetailsSoftwareVersion
            latestSoftwareVersion={props.latestSoftwareVersion}
            unitType='LCPPrimary'
            system={props.system}
          />
        </div>
      </div>
      {props.system?.lightningHardwareSystem?.secondaryControlPanel && (
        <div className='xl:flex xl:justify-between my-5 items-center'>
          <div className='xl:font-normal font-semibold w-48'>Secondary</div>
          <div className='2xl:gap-16 xl:flex gap-4'>
            {props.system?.lightningHardwareSystem?.secondaryControlPanel?.articleNumber && (
              <div className='xl:w-42 flex justify-between'>
                Part no.
                <span className='font-code prose-dataBaseDataLabel ml-3'>
                  {props.system?.lightningHardwareSystem?.secondaryControlPanel?.articleNumber}
                </span>
              </div>
            )}
            {props.system?.lightningHardwareSystem?.secondaryControlPanel?.serialNumber && (
              <div className='xl:w-32 flex justify-between'>
                Serial no.
                <span className='font-code prose-dataBaseDataLabel ml-3'>
                  {isHumphreeUser ? (
                    <Link
                      to={'/units/lcp/' + props.system.lightningHardwareSystem?.secondaryControlPanel?.serialNumber}
                      className='whitespace-nowrap cursor-pointer underline text-primary-100 hover:text-primary-200'
                    >
                      {props.system?.lightningHardwareSystem?.secondaryControlPanel?.serialNumber?.toString()}
                    </Link>
                  ) : (
                    props.system?.lightningHardwareSystem?.secondaryControlPanel?.serialNumber?.toString()
                  )}
                </span>
              </div>
            )}
            {props.system?.lightningHardwareSystem?.secondaryControlPanel?.firmwareVersion && (
              <div className='xl:w-42 flex justify-between items-center'>
                Software
                <span className='font-code prose-dataBaseDataLabel ml-3 xl:w-12 xl:truncate'>
                  {props.system.lightningHardwareSystem?.secondaryControlPanel?.firmwareVersion}
                </span>
              </div>
            )}
            <SystemDetailsSoftwareVersion
              latestSoftwareVersion={props.latestSoftwareVersion}
              unitType='LCPSecondary'
              system={props.system}
            />
          </div>
        </div>
      )}
    </div>
  );
}
